<section class="w-185 flex flex-col flex-wrap shadow-nx rounded-gt-md-7 p-12 box-content">
    <span class="gt-greytip-header-logo mb-20 block m-auto" *ngIf="!disableGreytHrLogo"></span>
    <div>
        <ng-container>
            <div class="saml-info"></div>
            <div class="mt-5">
                <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-50 bg-std-info mb-5">
                    <div class="text-7gpx text-text-default-1 mb-2 font-body-semibold font-semibold">
                        Sorry! Account locked
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body">
                        Please connect with your site administrator.
                    </div>
                </div>     
                <button 
                    class="mb-5 bg-primary h-21 items-center justify-center text-white flex w-full text-7gpx font-semibold font-body-semibold rounded-gt-md-3"
                    type="submit" (click)="returnToLogin()">
                    Try with greytHR Login
                </button>
                <div class="flex w-full justify-start font-body-semibold">
                    <a 
                        class="text-primary text-7gpx font-semibold cursor-pointer"
                        (click)="redirectToApp()">
                        Go back to log in
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</section>
